// extracted by mini-css-extract-plugin
module.exports = {"container":"shift-cashier-history_container__8_dN2","details":"shift-cashier-history_details__2R7Z4","details-ltr":"shift-cashier-history_details-ltr__3YFp9"};